export class Controller {

    /** @ngInject */
    constructor(ApplicationsResource) {
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
    }

    unassign() {
        this.isSaving = true;
        this.ApplicationsResource
            .unassignGroup(
                this.resolve.companyId,
                this.resolve.applicationId,
                this.resolve.groupId,
            )
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/unassign-group/unassign-group.controller.js